module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("icon", function() {
    return [_c('rt-icon', {
      attrs: {
        "name": _vm.icon,
        "img-src": _vm.iconSrc,
        "color": _vm.iconColor
      }
    })]
  }), _vm._v(" "), _c('span', {
    staticClass: "rt-tag-text"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c91026c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tag/rtTag.vue
// module id = 1541
// module chunks = 124